<div class="flex flex-row gap-4 mt-2">
    <div
        class="basis-1/2">
        <nx-headline-box  
        [label]="'Zahlung'">
        <ng-template nxTemplate="end">
            <nx-default-button
            (click)="editPaymentMethod(paymentMethod)"
            [tooltip]="'Zahlungsmethode bearbeiten'"
            [icon]="'icon-edit'"
            [style]="'light'">
            </nx-default-button>
        </ng-template>
        </nx-headline-box>
        <nx-default-box
        class="bg-white border-b border-gray"
        [label]="'Zahlungsmethode'">
        {{paymentMethod? PaymentSubscription.getPayementType(paymentMethod): '-'}}
        </nx-default-box>
    </div>
    <div
        class="basis-1/2">
    </div>
</div>